import { Company } from "@mapmycustomers/shared/types/entity";

import customFieldsToFormValues from "@app/util/form/customFieldsToFormValues";
import locatedToAddress from "@app/util/locatedToAddress";

import DetailsFormValues from "../Details/DetailsFormValues";

const companyToFormValues = (company: Company): DetailsFormValues => ({
  addressDetails: locatedToAddress(company),
  annualRevenue: company.annualRevenue,
  cadenceInterval: company.cadenceInterval,
  // we use legacyColor because we use /pins endpoint to fetch record details
  // and since we also use pin legends in that request, we should use legacyColor
  // field in order to get record's own color
  color: company.legacyColor,
  crmActivityTypeId: company.crmActivityTypeId,
  customFields: customFieldsToFormValues(company.customFields),
  email: company.email,
  groups: new Set((company.groups ?? []).map(({ id }) => id)),
  latitude: company.geoPoint ? String(company.geoPoint.coordinates[1]) : "",
  longitude: company.geoPoint ? String(company.geoPoint.coordinates[0]) : "",
  name: company.name,
  numEmployees: company.numEmployees,
  parentCompanyId: company.parentAccount?.id,
  parentCompanyName: company.parentAccount?.name,
  phone: company.phone,
  user: company.user.id,
  website: company.website,
});

export default companyToFormValues;
